import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "../lib/api";
import { SlateTab, PredictionsTab } from "./NFL";
import LikelyCash from "./LikelyCash";
import PropsThatPay from "./PropsThatPay";
import TeamMatchup from "./TeamMatchup";
import { useBookLinks } from "../components/BookLinks";

const TABS = [
  { key: "slate", label: "Slate & Lines" },
  { key: "predictions", label: "Game Predictions" },
  { key: "cash", label: "Likely to Cash" },
  { key: "props-pay", label: "Props That Pay" },
  { key: "matchup", label: "Matchup Lab" },
];

export default function Soccer() {
  const { tab: tabParam } = useParams();
  const navigate = useNavigate();
  const tab = TABS.some((t) => t.key === tabParam) ? tabParam : "slate";
  const setTab = (k) => navigate(k === "slate" ? "/soccer" : `/soccer/${k}`);
  const [comp, setComp] = useState("eng.1");
  const { data: lg } = useQuery({ queryKey: ["soccerLeagues"], queryFn: () => api.get("/soccer/leagues").then((r) => r.data), staleTime: Infinity });
  const leagues = lg?.leagues || [];
  const { urls } = useBookLinks();
  return (
    <div className="space-y-5">
      <div className="fade-up">
        <h1 className="font-display text-3xl md:text-4xl font-black uppercase tracking-tight">Soccer <span className="gold-text">{leagues.find((l) => l.comp === comp)?.name || ""}</span></h1>
        <p className="text-neutral-500 text-sm mt-1">The pitch sheet: pick a league, then work the slate — live lines, market-driven predictions, likely winners and props that pay.</p>
      </div>
      <div className="flex gap-2 overflow-x-auto fade-up-1" data-testid="soccer-league-tabs">
        {leagues.map((l) => (
          <button key={l.comp} onClick={() => setComp(l.comp)} data-testid={`soccer-league-${l.comp}`}
            className={`shrink-0 text-[11px] font-black uppercase tracking-widest px-3 py-1.5 rounded-full border transition-colors duration-200 ${comp === l.comp ? "bg-[#22c55e] text-black border-[#22c55e]" : "border-white/15 text-neutral-400 hover:border-[#22c55e]/60 hover:text-[#22c55e]"}`}>
            {l.name}
          </button>
        ))}
      </div>
      <div className="flex gap-2 overflow-x-auto fade-up-1" data-testid="soccer-tabs">
        {TABS.map((t) => (
          <button key={t.key} onClick={() => setTab(t.key)} data-testid={`soccer-tab-${t.key}`}
            className={`shrink-0 text-xs font-black uppercase tracking-widest px-4 py-2 rounded-full border transition-colors duration-200 ${tab === t.key ? "bg-[#a855f7] text-black border-[#a855f7]" : "border-white/15 text-neutral-400 hover:border-[#a855f7]/60 hover:text-[#a855f7]"}`}>
            {t.label}
          </button>
        ))}
      </div>
      <div className="fade-up-1">
        {tab === "slate" && <SlateTab urls={urls} league="soccer" endpoint={`/soccer/board?comp=${comp}`} />}
        {tab === "predictions" && <PredictionsTab league="soccer" endpoint={`/soccer/predictions?comp=${comp}`} />}
        {tab === "cash" && <LikelyCash league="soccer" comp={comp} />}
        {tab === "props-pay" && <PropsThatPay league="soccer" comp={comp} />}
        {tab === "matchup" && <TeamMatchup league="soccer" comp={comp} />}
      </div>
    </div>
  );
}
